import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

/**
 * Service to route API calls to the correct backend
 * Supports both Node.js (REST API) and Python backends
 */
@Injectable({ providedIn: "root" })
export class ApiRouterService {
  /**
   * Get the Python backend base URL
   * Used for Python-specific endpoints and services
   */
  getPythonUrl(): string {
    return environment.apiPythonBaseUrl || "http://localhost:8000/";
  }

  /**
   * Get the Node.js backend base URL
   * Used for existing REST API endpoints
   */
  getNodeUrl(): string {
    return environment.apiBaseUrl;
  }

  /**
   * Get the appropriate URL for a given service type
   * @param serviceType 'node' for Node.js backend, 'python' for Python backend
   * @returns The base URL for the specified service
   */
  getApiUrl(serviceType: "node" | "python"): string {
    return serviceType === "python" ? this.getPythonUrl() : this.getNodeUrl();
  }
}
